import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var OfficeBuildingSvg = function OfficeBuildingSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.432 2.249H3.131v18.639H2v1.361h5.71v-1.361H4.489v-9.892h6.334V9.635H4.488V7.009h3.855V5.647H4.488V3.61h9.587v4.023h1.357z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.494 10.513a3.387 3.387 0 0 1 4.798 0 3.41 3.41 0 0 1 0 4.814 3.39 3.39 0 0 1-4.798 0 3.41 3.41 0 0 1 0-4.814m2.399.365c-.54 0-1.058.215-1.44.598a2.045 2.045 0 0 0 1.44 3.486c.54 0 1.058-.215 1.44-.598a2.046 2.046 0 0 0 0-2.888 2.03 2.03 0 0 0-1.44-.598M21.613 18.974a13.3 13.3 0 0 0-5.72-1.289 13.26 13.26 0 0 0-5.72 1.29l-.387.184v3.064H22V19.16zm-5.72.073a11.9 11.9 0 0 1 4.75.981v.834h-9.5v-.834a11.9 11.9 0 0 1 4.75-.981",
    clipRule: "evenodd"
  }));
};
export var OfficeBuilding = function OfficeBuilding(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: OfficeBuildingSvg
  }));
};